import React from 'react';
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { Flex } from '@finect/tabular-core/Flex';
import { Icon } from '../../../Icon';
export var Label = styled.span.withConfig({
  displayName: "ManagerLabel__Label",
  componentId: "sc-f4z4pd-0"
})(["position:relative;top:6px;left:10px;"]);
export var LabelLink = styled(AppLink).withConfig({
  displayName: "ManagerLabel__LabelLink",
  componentId: "sc-f4z4pd-1"
})(["position:relative;top:6px;left:10px;"]);
export var ManagerLabel = function ManagerLabel(_ref) {
  var manager = _ref.manager,
    isPartner = _ref.isPartner;
  var withLink = manager && manager.features.blog;
  var Component = withLink ? LabelLink : Label;
  var managerLinkProps = withLink ? isPartner ? {
    title: manager.displayName,
    as: 'a',
    href: "https://www.finect.com/grupos/".concat(manager.alias)
  } : {
    title: manager.displayName,
    as: Link,
    to: "/grupos/".concat(manager.alias)
  } : {};
  return React.createElement(Flex, null, React.createElement(Icon, {
    size: 1,
    type: "organization",
    alt: manager.displayName,
    image: "https://www.finect.com/image/".concat(manager.icon),
    withBorder: true,
    withMargin: true,
    fill: "#fff"
  }), React.createElement(Component, managerLinkProps, manager.displayName));
};